import React, {Component} from 'react';
import { connect } from 'react-redux';
import FilterButton from "../filterbutton/filterbutton.component";
import { getAllTags } from '../../../SHARED/actions/tags.actions';
import { Link } from 'react-router-dom';
import { slugify } from "../../../SHARED/helpers/general.helper";

class SearchByTag extends Component {

    componentWillMount() {
        this.props.getAllTags();
    }

    showTags = () => {
        return this.props.tags.map((tag, i) => {
            return (
                <Link to={'/tag/' + slugify(tag.name) } key={i}>
                    <FilterButton interactivity={false} appearance={'styled'} label={tag.name} id={tag.id} />
                </Link>
            );
        });
    };

    render() {
        return (
            <div className="search-by-tag">
                <p className="dark-grey-text">Caută după tag</p>

                <div className="filters-buttons">
                    { this.showTags() }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tags: state.tags
});
export default connect(mapStateToProps, {getAllTags})(SearchByTag);





// WEBPACK FOOTER //
// ./src/SHARED/components/searchbytag/searchbytag.component.js